import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Kicker } from "./shared";

const ROWS = [
  {
    num: "01",
    kicker: "Jednoduchost",
    title: "Nasypte. Stiskněte. Nalévejte.",
    text: "Zelená zrnka do násypníku, jedno tlačítko — a za patnáct minut voní celý domov čerstvě praženou kávou. Žádné učení, žádné starosti.",
    img: "/img/pour.webp",
    alt: "Sypání zelených kávových zrn do BeanGo Cube X",
  },
  {
    num: "02",
    kicker: "Design",
    title: "Pražírna, která zapadne všude.",
    text: "Čisté linie, kov a dřevo. Cube X vypadá stejně dobře na kuchyňské lince jako na baru v kavárně — a zabere méně místa než kávovar.",
    img: "/img/cafe.webp",
    alt: "BeanGo Cube X na baru v kavárně",
  },
];

function StoryRow({ row, flip }) {
  return (
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 py-20 sm:py-28 lg:grid-cols-2 lg:gap-20">
      <Reveal className={flip ? "lg:order-2" : ""}>
        <div className="flex items-baseline gap-6">
          <span className="text-outline font-display text-7xl font-black leading-none sm:text-8xl" aria-hidden="true">
            {row.num}
          </span>
          <Kicker>{row.kicker}</Kicker>
        </div>
        <h2 className="mt-6 font-display text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl md:text-5xl">
          {row.title}
        </h2>
        <p className="mt-6 max-w-md text-base leading-relaxed text-stone-600 sm:text-lg">{row.text}</p>
      </Reveal>
      <Reveal delay={0.15} className={flip ? "lg:order-1" : ""}>
        <div className="group overflow-hidden rounded-lg border border-stone-200 shadow-sm">
          <img
            src={row.img}
            alt={row.alt}
            loading="lazy"
            className="w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-105"
          />
        </div>
      </Reveal>
    </div>
  );
}

function BeansBreak() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <div ref={ref} className="relative h-[70vh] overflow-hidden" data-testid="story-beans-break">
      <motion.img
        src="/img/beans.webp"
        alt="Čerstvě pražená kávová zrnka"
        style={{ y }}
        className="absolute inset-0 h-[124%] w-full object-cover"
      />
      <div className="absolute inset-0 bg-black/45" aria-hidden="true" />
      <div className="relative flex h-full items-center justify-center px-6 text-center">
        <Reveal>
          <h2 className="mx-auto max-w-4xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tighter text-white sm:text-6xl md:text-7xl">
            Čerstvost, kterou poznáte na první doušek.
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base text-stone-200 sm:text-lg">
            Pražíte vždy jen tolik kávy, kolik zrovna vypijete. Žádné skladování, žádné vyšisování chuti.
          </p>
        </Reveal>
      </div>
    </div>
  );
}

export default function Story() {
  return (
    <section id="prazicka" className="relative bg-white" data-testid="story-section">
      <StoryRow row={ROWS[0]} flip={false} />
      <BeansBreak />
      <StoryRow row={ROWS[1]} flip={true} />
    </section>
  );
}
